<template>
  <img v-if="image"
       :class="imageClass + ' flex-shrink-0 flex-grow-0'"
       :src="image"
       class="rounded-circle"
       alt=""
       loading="lazy"
       style="object-fit: cover;"
  />

  <div v-if="!image" :class="imageClass + ' flex-shrink-0 flex-grow-0'" class="rounded-circle bg-body d-flex align-items-center justify-content-center text-white flex-shrink-0">

    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-person" viewBox="0 0 16 16">
      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"/>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    image: {
      type: String,
    },
    imageClass: {
      type: String,
      default: "w-25px h-25px"
    }
  }
}
</script>
